import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router'
import { useState, useEffect } from 'react'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import { NotesSidebar } from '@/pages/Notes/NotesSidebar'
import { NoteEditorPage } from '@/pages/Notes/NoteEditorPage'
import { GOVUK_COLOURS } from '@/components/govuk/colours'
import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'

export const Route = createFileRoute('/notes')({
  component: NotesLayout,
})

function NotesLayout() {
  const [isHydrated, setIsHydrated] = useState(false)
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  if (!isHydrated) return null

  // ── Mobile ────────────────────────────────────────────────────────────────
  if (!isDesktop) return <Outlet />

  // ── Desktop ───────────────────────────────────────────────────────────────
  const isIndex = pathname === '/notes' || pathname === '/notes/'

  return (
    <Box
        sx={{
          display: 'flex',
          height: 'calc(100vh - 64px)',
          overflow: 'hidden',
        }}
      >
        {/* Left sidebar */}
        <Box
          sx={{
            width: 220,
            minWidth: 220,
            flexShrink: 0,
            borderRight: `1px solid ${GOVUK_COLOURS.midGrey}`,
            overflowY: 'auto',
            backgroundColor: '#fafafa',
          }}
        >
          <NotesSidebar />
        </Box>

        {/* Right editor */}
        <Box sx={{ flex: 1, overflowY: 'auto', minWidth: 0 }}>
          {isIndex ? <NoteEditorPage /> : <Outlet />}
        </Box>
      </Box>
  )
}
